<template>
    <div class="container-fluid mt-5 mb-6 mt-lg-6 mb-lg-9">
        <div class="row justify-content-center">
            <div class="col-xl-6 order-xl-1">
                <card shadow type="secondary">
                    <div slot="header" class="bg-white border-0">
                        <div class="row align-items-center">
                            <div class="col-8">
                                <h3 class="mb-0">{{ $t('logout_from_system') }}</h3>
                            </div>
                        </div>
                    </div>
                    <template>
                        <div class="pl-lg-4">
                            <div class="row">
                                <div class="col-lg-12">
                                    <base-alert type="danger" v-if="error">{{error}}</base-alert>
                                </div>
                            </div>
                        </div>


                    </template>
                </card>
            </div>
        </div>
    </div>

</template>
<script>


    import userApi from "../data/UserApi";
    import {destroyUser, getUser} from "../data/jwt.service";

    export default {
        name: 'user-logout',
        data() {
            return {
                error: null,
            }
        },

        mounted() {
            if (getUser()) {
                this.loading = true
                userApi.logout()
                    .then(response => {
                        this.$router.push('/user/signin')
                        destroyUser()
                    })
                    .catch(error => {
                        let data = error.response.data
                        this.error = this.pretty(data)
                        this.loading = false
                    })
            } else {
                this.$router.push('/user/signin')
            }
        },

        methods: {
            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    }
</script>
<style>
</style>
